import React from 'react';

const Message = ({text}) => {
  return (
    <div className="w-full h-auto overflow-auto border p-4 rounded-md">
      <div className={`grid gap-1 justify-center items-center`}>
        {text}
      </div>
    </div>
  );
};

export default Message;